import { Navigate, useParams } from 'react-router-dom';

import { useGetSubCategoria } from '@/shared/actions/erp/compras/subcategorias-productos.actions';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveSubcategorias } from '../../shared/saveSubCategoriasProductos';
import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';

export interface UpdateSubcategoriasPageInterface {}

const UpdateSubcategoriasPage: React.FC<UpdateSubcategoriasPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_subcategoriaproducto)
  const { id } = useParams();
  const { data, isLoading } = useGetSubCategoria(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_subcategoriaproducto) return <Navigate to="/inventario/subcategoria-productos" />;

  return <SaveSubcategorias titlePage="Editar Subcategorias del producto" editSubcategorias={data.data} />;
};

export default UpdateSubcategoriasPage;
